import React from "react";

const WithdrawIcon = ({color}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 21L11.4832 21.5435L12 22.0349L12.5168 21.5435L12 21ZM17.5862 16.1434H20V14.6434H17.5862V16.1434ZM20 2.25H4V3.75H20V2.25ZM4 16.1434H6.41379V14.6434H4V16.1434ZM2.25 4V6.2459H3.75V4H2.25ZM2.25 6.2459V14.3934H3.75V6.2459H2.25ZM21.75 14.3934V6.2459H20.25V14.3934H21.75ZM21.75 6.2459V4H20.25V6.2459H21.75ZM3 6.9959H21V5.4959H3V6.9959ZM4.86207 10.2418H14.7931V8.7418H4.86207V10.2418ZM11.25 12.4426V21H12.75V12.4426H11.25ZM12.5168 20.4565L8.48231 16.6204L7.44872 17.7075L11.4832 21.5435L12.5168 20.4565ZM12.5168 21.5435L16.5513 17.7075L15.5177 16.6204L11.4832 20.4565L12.5168 21.5435ZM4 14.6434C3.86193 14.6434 3.75 14.5315 3.75 14.3934H2.25C2.25 15.3599 3.0335 16.1434 4 16.1434V14.6434ZM4 2.25C3.0335 2.25 2.25 3.0335 2.25 4H3.75C3.75 3.86193 3.86193 3.75 4 3.75V2.25ZM20 3.75C20.1381 3.75 20.25 3.86193 20.25 4H21.75C21.75 3.0335 20.9665 2.25 20 2.25V3.75ZM20 16.1434C20.9665 16.1434 21.75 15.3599 21.75 14.3934H20.25C20.25 14.5315 20.1381 14.6434 20 14.6434V16.1434Z"
				fill={color ? "#9281FF" : "#64748B"}
			/>
		</svg>
	);
};

export default WithdrawIcon;
